import React, { useEffect, useState } from 'react';
import { Editor } from '@tinymce/tinymce-react';
import { FormLabel } from 'carbon-components-react';
import "./RichTextArea.scss"

function RichTextArea(props) {

    const [intialValue, setInitialValue] = useState()

    useEffect(() => {
        setInitialValue(props.value)
    }, [])

    const label = (props.labelText) ? (
        <FormLabel>
            {props.labelText}
        </FormLabel>
    ) : null

    const handleEditorChange = (content, editor) => {
        props.onChange(editor.getContent())
    }

    const editor =
        // useMemo(() => {
        //     return 
        (
            <Editor
                // key={`rich-text-editor-${props.id}${key}`}
                initialValue={intialValue}
                apiKey={process.env.REACT_APP_TINYMCE_APP_KEY}
                // outputFormat="text"
                init={{
                    formats: { underline: { inline: 'u', exact: true } },
                    height: 200,
                    menubar: false,
                    forced_root_block: false,
                    paste_as_text: true,
                    plugins: [
                        'advlist autolink lists link image charmap print preview anchor',
                        'searchreplace visualblocks code fullscreen',
                        'insertdatetime media table paste code help wordcount'
                    ],
                    //         toolbar:
                    //             'undo redo | formatselect | bold italic backcolor | \
                    //  alignleft aligncenter alignright alignjustify | \
                    //  bullist numlist outdent indent | removeformat | help'
                    toolbar:
                        'undo redo | bold italic link underline | insertTitleButton insertWebcastButton | removeformat | mybutton menuDateButton',
                    // formats: {
                    //     // A custom format that wraps blocks into a div with the specified wrapper class
                    //     'custom-wrapper': { block: 'div', classes: 'wrapper', wrapper: true, merge_siblings: false }
                    // },

                    setup: function (editor) {

                        let editorItems = props.hideVariables ? [] : [
                            {
                                type: 'menuitem',
                                text: 'WEBCAST_LINK',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[WEBCAST_LINK]{$selection}[/WEBCAST_LINK]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'EVALUATION_FORM_LINK',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[EVALUATION_FORM_LINK]{$selection}[/EVALUATION_FORM_LINK]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'WEBCAST_TEST_LINK',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[WEBCAST_TEST_LINK]{$selection}[/WEBCAST_TEST_LINK]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'IF_EMPTY_LIST',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[IF_EMPTY_LIST]{$selection}[/IF_EMPTY_LIST]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'IF_NOT_EMPTY_LIST',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[IF_NOT_EMPTY_LIST]{$selection}[/IF_NOT_EMPTY_LIST]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{LIVE_CALENDAR_LIST}} (CTIO 2022 ONLY!!!)',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{LIVE_CALENDAR_LIST}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{VOD_CALENDAR_LIST}} (CTIO 2022 ONLY!!!)',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{VOD_CALENDAR_LIST}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{NAME}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{NAME}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{FIRSTNAME}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{FIRSTNAME}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{EVENT_TITLE}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{EVENT_TITLE}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{EPISODE_TITLE}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{EPISODE_TITLE}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{WEBSITE_URL}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{WEBSITE_URL}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{SUPPORT_EMAIL}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{SUPPORT_EMAIL}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{SUPPORT_EMAIL_LINK}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{SUPPORT_EMAIL_LINK}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{CLIENT_NAME}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{CLIENT_NAME}}');
                                }
                            },
                            // {
                            //     type: 'menuitem',
                            //     text: '{{FAQ_LINK}}',
                            //     // icon: 'insertdatetime',
                            //     onAction: function () {
                            //         editor.insertContent('{{FAQ_LINK}}');
                            //     }
                            // },
                            {
                                type: 'menuitem',
                                text: '{{LIVE_DATETIME}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{LIVE_DATETIME}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{VOD_DATETIME}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{VOD_DATETIME}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{VOD_HOURS}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{VOD_HOURS}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{WEBSITE_CONTACTS}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{WEBSITE_CONTACTS}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{VIRTUAL_WORLD_OPEN_AT}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{VIRTUAL_WORLD_OPEN_AT}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{EPISODES_TITLE_LIST}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{EPISODES_TITLE_LIST}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{SUBSCRIBER_EPISODES_LIST}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{SUBSCRIBER_EPISODES_LIST}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{EPISODE_TAGS_LIST}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{EPISODE_TAGS_LIST}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'TOS_POPUP',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[TOS_POPUP]{$selection}[/TOS_POPUP]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'EXTERNAL_LINK',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[EXTERNAL_LINK]{$selection}[/EXTERNAL_LINK]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'QR_CODE',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[QR_CODE]{$selection}[/QR_CODE]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'EMAIL_VALIDATION_LINK',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[EMAIL_VALIDATION_LINK]{$selection}[/EMAIL_VALIDATION_LINK]');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{BULLET}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{BULLET}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: '{{BREAKOUT_NAME}}',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.insertContent('{{BREAKOUT_NAME}}');
                                }
                            },
                            {
                                type: 'menuitem',
                                text: 'UNSUBSCRIBE_LINK',
                                // icon: 'insertdatetime',
                                onAction: function () {
                                    editor.execCommand('mceReplaceContent', false, '[UNSUBSCRIBE_LINK]{$selection}[/UNSUBSCRIBE_LINK]');
                                }
                            },
                            // {
                            //     type: 'nestedmenuitem',
                            //     text: 'Other formats',
                            //     getSubmenuItems: function () {
                            //         return [
                            //             {
                            //                 type: 'menuitem',
                            //                 text: 'GMT',
                            //                 onAction: function () {
                            //                     editor.insertContent("toGmtHtml(new Date())");
                            //                 }
                            //             },
                            //             {
                            //                 type: 'menuitem',
                            //                 text: 'ISO',
                            //                 onAction: function () {
                            //                     editor.insertContent("toIsoHtml(new Date())");
                            //                 }
                            //             }
                            //         ];
                            //     }
                            // }
                        ];

                        if (props.isContacts) {
                            editorItems = editorItems.concat([
                                {
                                    type: 'menuitem',
                                    text: 'FAQ_POPUP',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.execCommand('mceReplaceContent', false, '[FAQ_POPUP]{$selection}[/FAQ_POPUP]');
                                    }
                                }])
                        }
                        if (props.isReminder) {
                            editorItems = editorItems.concat([
                                {
                                    type: 'menuitem',
                                    text: '{{LIVE_ICS_CALENDAR_LIST}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{LIVE_ICS_CALENDAR_LIST}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: '{{VOD_ICS_CALENDAR_LIST}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{VOD_ICS_CALENDAR_LIST}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: '{{REMINDERS_LIST}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{REMINDERS_LIST}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: '{{REMINDERS_NOTES}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{REMINDERS_NOTES}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: '{{EXPIRE_RESET_PASSWORD_TIME}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{EXPIRE_RESET_PASSWORD_TIME}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: '{{SUBSCRIBER_RESET_PASSWORD_LINK}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{SUBSCRIBER_RESET_PASSWORD_LINK}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: '{{SUBSCRIBER_RESET_PASSWORD_URL}}',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.insertContent('{{SUBSCRIBER_RESET_PASSWORD_URL}}');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: 'CURRENT_EPISODE_DIRECT_LINK',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.execCommand('mceReplaceContent', false, '[CURRENT_EPISODE_DIRECT_LINK]{$selection}[/CURRENT_EPISODE_DIRECT_LINK]');
                                    }
                                },
                                {
                                    type: 'menuitem',
                                    text: 'EPISODE_DIRECT_LINK',
                                    // icon: 'insertdatetime',
                                    onAction: function () {
                                        editor.execCommand('mceReplaceContent', false, '[EPISODE_DIRECT_LINK?episode_id={EPISODE_ID}]{$selection}[/EPISODE_DIRECT_LINK]');
                                    }
                                },
                            ])
                        }
                        // editor.ui.registry.addButton('myCustomToolbarButton', {
                        //     text: 'My Custom Button',
                        //     icon: 'insertdatetime',
                        //     onAction: function (selected) {
                        //         console.log("myCustomToolbarButton", selected)
                        //         alert('Button clicked!');
                        //     }
                        // });
                        // editor.ui.registry.addButton('insertTitleButton', {
                        //     text: '{{TITLE}}',
                        //     // icon: 'insertdatetime',
                        //     onAction: function () {
                        //         editor.insertContent('{{TITLE}}');
                        //     }
                        // });
                        // editor.ui.registry.addButton('insertWebcastButton', {
                        //     text: '{{WEBCAST}}',
                        //     // icon: 'insertdatetime',
                        //     onAction: function () {
                        //         editor.insertContent('{{WEBCAST}}');
                        //     }
                        // });
                        if (!props.hideVariables) {
                            editor.ui.registry.addMenuButton('menuDateButton', {
                                text: 'Variables',
                                fetch: function (callback) {
                                    var items = editorItems
                                    callback(items);
                                }
                            });
                        }
                        // editor.ui.registry.addButton('mybutton', {
                        //     text: 'My Button2',
                        //     type: 'togglemenuitem',
                        //     onAction: function () {
                        //         console.log("toggleState", toggleState)
                        //         toggleState = !toggleState;
                        //         editor.insertContent('&nbsp;<em>You toggled a menuitem ' + (toggleState ? 'on' : 'off') + '</em>');
                        //     },
                        //     // onSetup: function (api) {
                        //     //     api.setActive(toggleState);
                        // });
                    },
                    content_style: 'body { font-family:Helvetica,Arial,sans-serif; font-size:14px }'

                }}

                onEditorChange={handleEditorChange}
            // onBlur={handleEditorChange}
            />
        )
    // }, [props.value, props.hideVariables])

    return (
        <>
            {label}
            {editor}
        </>
    )
}

export default RichTextArea